// Turns raw Firebase/callable errors into plain, non-technical copy for toasts.
// Falls back to the original message only when we have nothing better.
const CODE_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'That email or password is incorrect.',
  'auth/invalid-email': 'That email address doesn’t look right.',
  'auth/user-not-found': 'No account found with that email.',
  'auth/wrong-password': 'That email or password is incorrect.',
  'auth/email-already-in-use': 'An account with that email already exists. Try signing in.',
  'auth/weak-password': 'Choose a stronger password (at least 8 characters).',
  'auth/too-many-requests': 'Too many attempts. Wait a moment and try again.',
  'auth/popup-closed-by-user': 'Sign-in was cancelled.',
  'auth/popup-blocked': 'Your browser blocked the sign-in popup. Allow popups and try again.',
  'auth/network-request-failed': 'Network problem. Check your connection and try again.',
  'auth/requires-recent-login': 'For security, please sign in again to do this.',
  'permission-denied': 'You don’t have permission to do that.',
  unauthenticated: 'Please sign in and try again.',
  unavailable: 'Service is temporarily unavailable. Try again in a moment.',
  'functions/permission-denied': 'You don’t have permission to do that.',
  'functions/unauthenticated': 'Please sign in and try again.',
  'functions/unavailable': 'Service is temporarily unavailable. Try again in a moment.',
};

export function friendlyError(err: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const code = (err as { code?: string })?.code;
  if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code];
  // Callable HttpsError messages are already human-written on the server — keep
  // those. Only the raw "Firebase: Error (auth/…)." strings are unhelpful.
  const message = err instanceof Error ? err.message : '';
  if (message && !/^Firebase:/i.test(message)) return message;
  return fallback;
}
